export const permissionsConstants = {
  VCM: "ROLE_VCM",
  FETCH_ISSUER_CONFIGS: "ROLE_FETCH_ISSUER_CONFIGS",
  VIEW_ALL: "ROLE_VIEW_ALL",

  CREATE_USER: "ROLE_CREATE_USER",
  ENABLE_USER: "ROLE_ENABLE_USER",
  VIEW_USERS: "ROLE_VIEW_USERS",
  VIEW_USER: "ROLE_VIEW_USER",
  UPDATE_USER: "ROLE_UPDATE_USER",
  DISABLE_USER: "ROLE_DISABLE_USER",

  CHANGE_USER_ROLE: "ROLE_CHANGE_USER_ROLE",
  DELETE_USER_ROLE: "ROLE_DELETE_USER_ROLE",
  DISABLE_USER_ROLE: "ROLE_DISABLE_USER_ROLE",
  ASSIGN_USER_ROLE: "ROLE_ASSIGN_USER_ROLE",
  VIEW_DOMAINS_ROLE: "ROLE_VIEW_DOMAINS",

  CREATE_CARD: "ROLE_CREATE_CARD",
  VIEW_CARD_REQUESTS: "ROLE_VIEW_CARD_REQUESTS",
  VIEW_CARD_REQUEST: "ROLE_VIEW_CARD_REQUEST",

  CREATE_ISSUER_MAPPING: "ROLE_CREATE_ISSUER_MAPPING",
  UPDATE_ISSUER_MAPPING: "ROLE_UPDATE_ISSUER_MAPPING",
  DELETE_ISSUER_MAPPING: "ROLE_DELETE_ISSUER_MAPPING",
  VIEW_ISSUER_MAPPINGS: "ROLE_VIEW_ISSUER_MAPPINGS",
  VIEW_ISSUER_MAPPING: "ROLE_VIEW_ISSUER_MAPPING",

  VIEW_ISSUER_CONFIGURATIONS: "ROLE_VIEW_ISSUER_CONFIGURATIONS",
  VIEW_ISSUER_CONFIGURATION: "ROLE_VIEW_ISSUER_CONFIGURATION",
  CREATE_ISSUER_CONFIGURATION: "ROLE_CREATE_ISSUER_CONFIGURATION",
  UPDATE_ISSUER_CONFIGURATION: "ROLE_UPDATE_ISSUER_CONFIGURATION",
  DELETE_ISSUER_CONFIGURATION: "ROLE_DELETE_ISSUER_CONFIGURATION",

  VIEW_BATCH_CUSTOMERS: "ROLE_VIEW_BATCH_CUSTOMERS",
  VIEW_CUSTOMER_CARDS: "ROLE_VIEW_CUSTOMER_CARDS",
  GET_DOMAIN_CUSTOMERS: "ROLE_GET_DOMAIN_CUSTOMERS",
  VIEW_CUSTOMER: "ROLE_VIEW_CUSTOMER",

  VIEW_CARD_DETAILS: "ROLE_VIEW_CARD_DETAILS",
  VIEW_CARDS: "ROLE_VIEW_CARDS",

  VIEW_CARD_STATEMENT: "ROLE_VIEW_CARD_STATEMENT",
  DOWNLOAD_CARD_STATEMENT: "ROLE_DOWNLOAD_CARD_STATEMENT",

  BLOCK_CARD: "ROLE_BLOCK_CARD",
  UNBLOCK_CARD: "ROLE_UNBLOCK_CARD",
  REISSUE_PIN: "ROLE_REISSUE_PIN",

  VIEW_ACTIVITY_LOG: "ROLE_VIEW_ACTIVITY_LOG",
};

export const createPermissions = () => {
  const permissions = [];
  for (var permission in permissionsConstants) {
    permissions.push(permissionsConstants[permission]);
  }

  return permissions;
};

export const permissions = createPermissions();
